import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppModule } from './app/app.module';
if (environment.production) {
  enableProdMode();

  // Register the service worker if in production mode
  ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
